import React from 'react';

import { validateFloatNumber } from '@/utils/Util';

const AlertQuantityPopup = ({ markMaterialForAlert, alertQuantity, setAlertQuantity }) => {
	return (
		<div className="alert-quantity-popup">
			<div className="form-group mb-0">
				<label htmlFor="alert-quantity">Mark for Alert</label>
				<input
					type="text"
					id="alert-quantity"
					placeholder="Set alert Qty"
					onChange={(e) => setAlertQuantity(e.target.value)}
					value={alertQuantity}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							markMaterialForAlert();
						}
					}}
					onKeyPress={validateFloatNumber}
				/>
			</div>
		</div>
	);
};

export default AlertQuantityPopup;
